export default __webpack_public_path__ + "static/media/like_outlined.4f6a41b2.svg";